'use client'
import Link from 'next/link'
import Image from 'next/image'
import basketProduct from '../../../public/basket-product.png'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import BasketPlusMinus from '../BasketPlusMinus'
import { BasketContext } from '../BasketProvider'
import { useK2Setup } from '@/eshop/hooks/useK2Setup'
import { parsePrice, useFormatPrice } from '@/eshop/utils/price'
import { TrashIcon } from '@heroicons/react/20/solid'
import { getBrandLogo } from '../ProductList/Table'

interface Props {
    isEditable?: boolean
}
export default function BasketProductTable({ isEditable = false }: Props) {
    const { products, removeProduct } = useContext(BasketContext)
    const { t } = useTranslation()
    const k2 = useK2Setup()
    const formatPrice = useFormatPrice(k2.currencyCode)

    return (
        <table className="table min-w-full w-max">
            <thead>
                <tr>
                    <th className="font-bold text-sm text-secondary uppercase">
                        {t('eshop.basket.table.product')}
                    </th>
                    <th className="font-bold text-sm text-secondary uppercase">
                        {t('eshop.basket.table.catalogueNo')}
                    </th>
                    <th className="font-bold text-sm text-secondary uppercase">
                        {t('eshop.basket.table.count')}
                    </th>
                    <th className="font-bold text-sm text-secondary uppercase">
                        {t('eshop.basket.table.content')}
                    </th>
                    <th className="font-bold text-sm text-secondary uppercase">
                        {t('eshop.basket.table.manufacturer')}
                    </th>
                    <th className="font-bold text-sm text-secondary uppercase">
                        {t('eshop.basket.table.price')}
                    </th>
                    {isEditable && <th></th>}
                </tr>
            </thead>
            <tbody>
                {products.length === 0 && (
                    <tr>
                        <td colSpan={isEditable ? 7 : 6}>
                            <div className="text-center text-lg">
                                {t('eshop.basket.table.empty')}
                            </div>
                        </td>
                    </tr>
                )}
                {products.map((p) => (
                    <tr key={p.id} className="border rounded">
                        <td>
                            <Link
                                href={p.link}
                                className="flex items-center gap-4"
                            >
                                <Image
                                    src={basketProduct}
                                    width={50}
                                    height={50}
                                    alt={p.name}
                                />

                                {p.name}
                            </Link>
                        </td>
                        <td>{p.catNo}</td>
                        <td>
                            {isEditable ? (
                                <BasketPlusMinus catNo={p.catNo} />
                            ) : (
                                <span>{p.count}</span>
                            )}
                        </td>
                        <td>{p.unit}</td>
                        <td>
                            {p.manufacturer && p.manufacturerId
                                ? getBrandLogo(
                                      p.manufacturerId!,
                                      p.manufacturer
                                  )
                                : p.manufacturer}
                        </td>
                        <td>
                            <span className="text-base">
                                {formatPrice(
                                    parsePrice(p.priceVAT) * p.count,
                                    true
                                )}
                            </span>
                            <br />
                            {formatPrice(parsePrice(p.price) * p.count, false)}
                        </td>
                        {isEditable && (
                            <td className="text-center">
                                <span
                                    className="hover:cursor-pointer tooltip"
                                    data-tip={t(
                                        'eshop.basket.table.removeProduct'
                                    )}
                                    onClick={() => removeProduct(p)}
                                >
                                    <TrashIcon
                                        width={24}
                                        height={24}
                                        fill="#FF4136"
                                    />
                                </span>
                            </td>
                        )}
                    </tr>
                ))}
            </tbody>
        </table>
    )
}
